/* eslint-disable @typescript-eslint/no-explicit-any */
interface Vilkaar {
  id: string;
  vilkaarTekster: VilkaarTekst[];
  opprettetDato: string;
  sistEndretData: string;
}

export interface VilkaarTekst {
  id: string;
  tekst: string;
  fullTekst: string;
  spraak: string;
  vilkaarId: string;
  opprettetDato: string;
  sistEndretData: string;
}

interface State {
  loadingVilkaar: boolean;
  vilkaar: Vilkaar | undefined;
}

export const initState: State = {
  loadingVilkaar: false,
  vilkaar: undefined,
};

export const UPDATE_STATE = 'EULA_UPDATE_STATE';
export const RESET_STATE = 'EULA_RESET_STATE';

export const eulaReducer = (state: State, action: { type: string; payload?: any }): State => {
  switch (action.type) {
    case UPDATE_STATE:
      return { ...state, ...action.payload };
    case RESET_STATE:
      return { ...initState };
    default:
      return state;
  }
};
